/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["quick-panel{display:flex;width:280px;min-width:280px;max-width:280px;z-index:99;flex-direction:column}quick-panel .mat-slide-toggle-content{flex:1}"];
export { styles as styles };
